// import React from 'react';
// import dayjs from 'dayjs';
import dayjs from 'dayjs';

// eslint-disable-next-line no-unused-vars
function getColmunsNew({ t }) {

  const inverterEvents = {
    SysM: t('box.notificationInverter.table.filter.sysm'),
    Pri: t('box.notificationInverter.table.filter.pri'),
    BtTy: t('box.notificationInverter.table.filter.btty'),
    SPHS: t('box.notificationInverter.table.filter.SPHS'),
    DerM: t('box.notificationInverter.table.filter.derm'),
    Even: t('box.notificationInverter.table.filter.even'),
    EGrid: t('box.notificationInverter.table.filter.egrid'),
  };

  const columns = [
    {
      title: t('box.notificationInverter.table.time'),
      dataIndex: 'time',
      defaultSortOrder: 'descend',
      sorter: (a, b) => a.time - b.time,
      render: (time) => dayjs(time).format('YYYY/MM/DD - HH:mm'),
    },
    {
      title: t('box.notificationInverter.table.name'),
      dataIndex: 'name',
      filters: [
        {
          text: 'SysM',
          value: 'SysM',
        },
        {
          text: 'Pri',
          value: 'Pri',
        },
        {
          text: 'BtTy',
          value: 'BtTy',
        },
        {
          text: 'SPHS',
          value: 'SPHS',
        },
        {
          text: 'DerM',
          value: 'DerM',
        },
      ],
      onFilter: (value, record) => record.name.indexOf(value) === 0,
      render: (name) => inverterEvents[name],
    },
    {
      title: t('box.notificationInverter.table.description'),
      dataIndex: 'description',
    },
  ];
  return columns;

}

export default getColmunsNew;
